import type { EntitySection } from '@/lib/entity-sections';

/*
 * Domain knowledge: the sub-sections a general-agent detail view exposes. Lives
 * in the feature (EntitySectionLayout and lib/entity-sections are domain-free).
 * Ported verbatim from the prototype's `ENTITY_SECTIONS['general-agents']`
 * (public/js/entity-sub-menu.js) so existing deep links keep working; `profile`
 * is the first section and the fallback.
 */
export const generalAgentSections: readonly EntitySection[] = [
  { id: 'profile', label: 'Profile' },
  { id: 'commissions', label: 'Commissions' },
  { id: 'contracts', label: 'Contracts' },
  { id: 'bank-accounts', label: 'Bank Accounts' },
  { id: 'disbursement-schedules', label: 'Disbursement Schedules' },
];
